const AboutSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-pink-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* صورة القسم */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/790251f5c7cebab795e064eda7592817.jpg"
                alt="Rose Mist Beauty Products"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-pink-900/20 to-transparent"></div>
            </div>
            {/* عنصر زخرفي */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-pink-200 rounded-full blur-3xl opacity-50"></div>
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-rose-200 rounded-full blur-3xl opacity-40"></div>
          </div>

          {/* المحتوى النصي */}
          <div className="order-1 lg:order-2 space-y-6">
            <div className="inline-block">
              <span className="text-pink-500 font-semibold text-sm tracking-wider uppercase bg-pink-50 px-4 py-2 rounded-full">
                من نحن
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              رحلتك نحو
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-400"> الجمال الطبيعي</span>
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              <strong className="text-pink-600">Rose Mist</strong> هي علامة تجارية رائدة في عالم التجميل والعناية بالبشرة، نؤمن بأن الجمال الحقيقي يبدأ من الداخل وينعكس على البشرة الصحية المشرقة.
            </p>

            <p className="text-gray-600 leading-relaxed">
              نقدم لكِ مجموعة مختارة بعناية من منتجات التجميل الفاخرة التي تجمع بين الفعالية العالية والمكونات الطبيعية النقية. كل منتج في Rose Mist مصمم خصيصاً لتعزيز جمالك الطبيعي ومنحك تجربة عناية فاخرة.
            </p>

            {/* القيم الأساسية */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              <div className="flex items-start gap-3 bg-white p-4 rounded-2xl shadow-sm border border-pink-100">
                <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full flex-shrink-0">
                  <i className="ri-leaf-line text-pink-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">مكونات طبيعية</h3>
                  <p className="text-sm text-gray-600">منتجات آمنة وفعالة من الطبيعة</p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white p-4 rounded-2xl shadow-sm border border-pink-100">
                <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full flex-shrink-0">
                  <i className="ri-shield-check-line text-pink-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">جودة مضمونة</h3>
                  <p className="text-sm text-gray-600">معايير عالمية في كل منتج</p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white p-4 rounded-2xl shadow-sm border border-pink-100">
                <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full flex-shrink-0">
                  <i className="ri-heart-line text-pink-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">صُنع بحب</h3>
                  <p className="text-sm text-gray-600">عناية فائقة في كل تفصيلة</p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white p-4 rounded-2xl shadow-sm border border-pink-100">
                <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full flex-shrink-0">
                  <i className="ri-sparkle-line text-pink-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">نتائج مذهلة</h3>
                  <p className="text-sm text-gray-600">تحول ملحوظ في بشرتك</p>
                </div>
              </div>
            </div>

            {/* زر الإجراء */}
            <div className="pt-4">
              <button className="group bg-gradient-to-r from-pink-500 to-rose-400 text-white px-8 py-4 rounded-full font-semibold hover:shadow-xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2">
                اكتشفي قصتنا
                <i className="ri-arrow-left-line group-hover:-translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div>
        </div>

        {/* إحصائيات */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-20">
          <div className="text-center p-6 bg-white rounded-2xl shadow-sm border border-pink-100">
            <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-400 mb-2">
              +10K
            </div>
            <p className="text-gray-600 font-medium">عميلة سعيدة</p>
          </div>

          <div className="text-center p-6 bg-white rounded-2xl shadow-sm border border-pink-100">
            <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-400 mb-2">
              +500
            </div>
            <p className="text-gray-600 font-medium">منتج فاخر</p>
          </div>

          <div className="text-center p-6 bg-white rounded-2xl shadow-sm border border-pink-100">
            <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-400 mb-2">
              100%
            </div>
            <p className="text-gray-600 font-medium">مكونات طبيعية</p>
          </div>

          <div className="text-center p-6 bg-white rounded-2xl shadow-sm border border-pink-100">
            <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-400 mb-2">
              5★
            </div>
            <p className="text-gray-600 font-medium">تقييم العملاء</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;